import React, { useEffect, useState, useCallback } from 'react';
import { CardImg, Input, Row, Col, Nav, NavItem, Navbar, NavbarBrand, NavbarToggler, Collapse, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle, NavbarText, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageBar from './LanguageBar';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';

import 'antd/dist/reset.css';
import { Menu } from 'antd';
import { DashboardOutlined } from '@ant-design/icons';
import { NodeExpandOutlined } from '@ant-design/icons';
import { FundProjectionScreenOutlined } from '@ant-design/icons';
import { ToolOutlined } from '@ant-design/icons';
import brandLogo from '../Assets/Images/brand/logo-color712x186.png';

const LeftMenu = () => {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    const [seed, setSeed] = useState(0);
    const [logged, setLogged] = useState(false);

    const [data, setData] = useState(null);
    const [menuData, setMenuData] = useState(null);

    const { SubMenu } = Menu;

    function handleClick(e) {
        //console.log('click', e);
    }

    useEffect(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            let currentSession = sessionStorage.getItem("currentSession");
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            let ApiGateway = process.env.REACT_APP_API_URL;
            axios.get(ApiGateway + '/access/login/menu')
                .then(response => {
                    setData(response.data);
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }, [t]);

    const listOfExpanded = useCallback(() => {
        let list = [];
        data?.payload?.map((item) => (
            <>
                {
                    item.header === true && (
                        list.push(item.id)
                    )
                }
            </>
        ))
        return list;
    }, [data]);

    const calculateSubMenu = useCallback((item) => {
        return (<>
            <SubMenu
                key={item?.id}
                title={
                    <span>
                        {item?.id === '41a15f4a-bec3-49ed-af5d-c8acac0d0ec4' ? <DashboardOutlined /> : null}
                        {item?.id === '9faf5529-aad8-4678-a91f-887479886f7d' ? <NodeExpandOutlined /> : null}
                        {item?.id === '613f6f0f-dc9c-4f0d-9578-487f4e87e882' ? <FundProjectionScreenOutlined /> : null}
                        {item?.id === 'aecfbb85-7773-447e-b69e-d9e6e5691ed8' ? <ToolOutlined /> : null}
                        <span>{t('language') === 'tr' ? item?.labelTr : item?.labelEn}</span>
                    </span>
                }
            >
                {item?.items?.map((subItem) => (
                    <>
                        {(subItem?.items !== null && subItem?.items?.length) > 0 ?
                            calculateSubMenu(subItem)
                            : <Menu.Item key={subItem?.id}><Link to={subItem?.link}><span>{t('language') === 'tr' ? subItem?.labelTr : subItem?.labelEn}</span></Link></Menu.Item>
                        }
                    </>
                ))}
            </SubMenu>
        </>);
    }, [t]);

    const calculateParentMenu = useCallback((data) => {
        let list = [];
        list = listOfExpanded();
        //console.log(list);
        return (<>
            {list !== null && list.length > 0 ?
                <Menu onClick={handleClick} style={{ width: '100%', backgroundColor: '#fff' }} mode="inline" inlineCollapsed={false} forceSubMenuRender={true}
                    defaultSelectedKeys={['41a15f4a-bec3-49ed-af5d-c8acac0d0ec4']}
                    defaultOpenKeys={list}
                >
                    {data?.payload?.map((item) => (
                        calculateSubMenu(item)
                    ))}
                </Menu>

                : null}
        </>);
    }, [calculateSubMenu, listOfExpanded]);



    useEffect(() => {
        setMenuData(
            calculateParentMenu(data)
        )
    }, [data, t, calculateParentMenu]);


    useEffect(() => {

    }, [logged]);

    const callLogout = (btn) => {
        //sessionStorage.removeItem("currentSession");
        //setSeed(Math.random());
        //Navigate('/logout');
        let redirectUrl = '/logout';
        window.location.href = redirectUrl;
    };


    return (
        <React.Fragment>
            <Row key={seed}>
                <Col className={'col-12 pull-left vh-100'} style={{ backgroundColor: '#ffffff' }}>
                    <div className='p-2' style={{ width: '300px' }}>
                        {menuData && menuData}
                    </div>
                </Col>
            </Row>
            <br /><br /><br />
        </React.Fragment >
    )
};

export default LeftMenu;